document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.querySelector('.warmth-guide-trigger');
  const drawer = document.querySelector('.warmth-guide-drawer');
  const overlay = document.querySelector('.warmth-guide-overlay');
  const close = document.querySelector('.warmth-guide-close');

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
  }

  trigger?.addEventListener('click', openDrawer);
  close?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
});